import { createSlice } from "@reduxjs/toolkit";

const CommercialModalSlice = createSlice({
  name: "CommercialModal",
  initialState: {
    formData: {
      SubPropertyType: "",
      area: "",
      rate: "",
    },
    Commercialshow: false, // Control the visibility of the modal
  },
  reducers: {
    setFormData(state, action) {
      state.formData = { ...state.formData, ...action.payload };
    },
    resetCommercialModalData(state) {
      state.formData = {
        SubPropertyType: "",
        area: "",
        rate: "",
      };
    },
    // Action to show the modal
    showCommercialModal(state) {
      state.Commercialshow = true;
    },
    // Action to hide the modal
    hideCommercialModal(state) {
      state.Commercialshow = false;
    },
  },
});

export const {
  setFormData,
  resetCommercialModalData,
  showCommercialModal,
  hideCommercialModal,
} = CommercialModalSlice.actions;

export default CommercialModalSlice.reducer;
